"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = initSidenav;
const element_toggler_1 = __importDefault(require("../../../../scripts/element-toggler"));
function initSidenav() {
    let $sidenav = null;
    try {
        $sidenav = document.getElementById('sidenav');
        if (!$sidenav)
            return;
        const actionButtons = document.querySelectorAll('[data-side-nav-action]');
        const toggleTrigger = [];
        const openTrigger = [];
        const closeTrigger = [];
        actionButtons.forEach($button => {
            const actionName = $button.getAttribute('data-side-nav-action');
            switch (actionName) {
                case 'close':
                    closeTrigger.push($button);
                    break;
                case 'open':
                    openTrigger.push($button);
                    break;
                case 'toggle':
                    toggleTrigger.push($button);
                    break;
                default:
                    break;
            }
        });
        (0, element_toggler_1.default)({
            $element: $sidenav,
            toggleTrigger,
            openTrigger,
            closeTrigger,
        });
    }
    catch (error) {
        console.error(error);
    }
    //
    //
    //
    let $sidenavCatalogList = null;
    try {
        $sidenavCatalogList = $sidenav.querySelector('.sidenav__catalog-list');
        const actionButtonsCatalogList = $sidenav.querySelectorAll('[data-side-nav-catalog-action]');
        const toggleCatalogList = [];
        const openCatalogList = [];
        const closeCatalogList = [];
        actionButtonsCatalogList.forEach($button => {
            const actionName = $button.getAttribute('data-side-nav-catalog-action');
            switch (actionName) {
                case 'close':
                    closeCatalogList.push($button);
                    break;
                case 'open':
                    openCatalogList.push($button);
                    break;
                case 'toggle':
                    toggleCatalogList.push($button);
                    break;
                default:
                    break;
            }
        });
        (0, element_toggler_1.default)({
            $element: $sidenavCatalogList,
            toggleTrigger: toggleCatalogList,
            openTrigger: openCatalogList,
            closeTrigger: closeCatalogList,
            onOpen: () => {
                actionButtonsCatalogList.forEach($button => {
                    $button.classList.add('sidenav__catalog-list-item--active');
                });
            },
            onClose: () => {
                actionButtonsCatalogList.forEach($button => {
                    $button.classList.remove('sidenav__catalog-list-item--active');
                });
            },
        });
    }
    catch (error) {
        console.error(error);
    }
    //
    //
    //
    try {
        const sidenavCatalogListItems = $sidenavCatalogList.querySelectorAll('[data-side-nav-subcatalog-action]');
        let $currentSidenavSubCatalogListOpened = null;
        sidenavCatalogListItems.forEach(($sidenavCatalogListItem) => {
            const $sidenavSubCatalogList = $sidenavCatalogListItem.nextElementSibling;
            const toggleCatalogList = [];
            const openCatalogList = [];
            const closeCatalogList = Array.from(sidenavCatalogListItems).filter($item => $item !== $sidenavCatalogListItem);
            const actionName = $sidenavCatalogListItem.getAttribute('data-side-nav-subcatalog-action');
            switch (actionName) {
                case 'close':
                    closeCatalogList.push($sidenavCatalogListItem);
                    break;
                case 'open':
                    openCatalogList.push($sidenavCatalogListItem);
                    break;
                case 'toggle':
                    toggleCatalogList.push($sidenavCatalogListItem);
                    break;
                default:
                    break;
            }
            (0, element_toggler_1.default)({
                $element: $sidenavSubCatalogList,
                toggleTrigger: toggleCatalogList,
                openTrigger: openCatalogList,
                closeTrigger: closeCatalogList,
                onOpen: () => {
                    if ($currentSidenavSubCatalogListOpened)
                        $sidenavCatalogListItem.classList.remove('sidenav__catalog-list-link--active');
                    $currentSidenavSubCatalogListOpened = $sidenavCatalogListItem;
                    $sidenavCatalogListItem.classList.add('sidenav__catalog-list-link--active');
                },
                onClose: () => {
                    $sidenavCatalogListItem.classList.remove('sidenav__catalog-list-link--active');
                },
            });
        });
    }
    catch (error) {
        console.error(error);
    }
}
